class LoadMoreButton extends HTMLElement {
    constructor() {
        super();
        this.addEventListener("click", this.loadMore);
    }

    loadMore(event) {
        if (event.target.classList.contains("checked")) {
            document.querySelectorAll("#load-plans").forEach(el => el.classList.remove("checked"));
            document.querySelectorAll("#plan-available-text").forEach(el => el.innerText = "Are you outside the US or Canada?");
            document.querySelectorAll(".regional").forEach((el) => {
                el.closest(".it-products-wrapper").style.display = "block";
            });
            document.querySelector(".international").closest(".it-products-wrapper").style.display = "none";
            if (document.getElementsByClassName("it-hero").length > 0) {
                document.querySelector(".it-hero").style.display = "block";
            }
        } else {
            document.querySelectorAll("#load-plans").forEach(el => el.classList.add("checked"));
            document.querySelectorAll("#plan-available-text").forEach(el => el.innerText = "In the US or Canada?");
            document.querySelectorAll(".regional").forEach((el) => {
                el.closest(".it-products-wrapper").style.display = "none";
            });
            document.querySelector(".international").closest(".it-products-wrapper").style.display = "block";
            if (document.getElementsByClassName("it-hero").length > 0) {
                document.querySelector(".it-hero").style.display = "none";
            }
        }

        window.scrollTo(0,0);
    }
}

customElements.define("load-more-button", LoadMoreButton);